import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9fd1146"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tooltip" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BulmaTooltip',
  props: {
  label: {
    type: String,
    default: ''
  },
  position: {
    validator(value: string) {
      return (new Set(['is-top', 'is-right', 'is-bottom', 'is-left', 'is-bottom-left'])).has(value)
    },
    default: 'is-top'
  },
  type: {
    validator(value: string) {
      return (new Set([
        'is-primary', 'is-danger',
        'is-warning', 'is-info'
      ])).has(value)
    },
    default: 'is-primary'
  },
  wrapText: Boolean,
  disabled: Boolean,
  forceVisible: Boolean,
  fixedWidth: {
    type: String
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("span", {
      class: _normalizeClass(["px-3 py-2", ['tooltiptext',
                  __props.position,
                  __props.type,
                  __props.forceVisible ? 'is-visible' : '',
                  __props.wrapText ? 'fixed-width' : 'no-wrap-ws']]),
      style: _normalizeStyle([__props.fixedWidth
             ? { width: __props.fixedWidth }
             : ''])
    }, _toDisplayString(__props.label), 7), [
      [_vShow, !__props.disabled]
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})